import {
  reactive, toRefs,
} from 'vue';
import _ from 'lodash';
import Shipping from '@/models/Shipping';
import { useToast } from 'vue-toastification';
import QtyOptions from '@/components/utils/QtyOptions';

export default function () {
  const state = reactive({
  });
  const toast = useToast();
  const getCatQTyMap = (item) => {
    const predicate = {};
    if (_.isEmpty(item.catId)) {
      predicate._id = item._id;
    } else {
      predicate.catId = item.catId;
    }
    const { catQtyMaps } = item;
    const catQtyMap = _.find(catQtyMaps, predicate);
    return catQtyMap;
  };
  const updateItemQty = (catQtyMap, item) => {
    catQtyMap.total = item.quantity;
    if(item.qtyReserved) {
      if(item.qtyReserved < (catQtyMap.qtyToConsume + catQtyMap.qtyToShip))  
        catQtyMap.qtyToReturn = 0;
      else
        catQtyMap.qtyToReturn = item.qtyReserved - (catQtyMap.qtyToConsume + catQtyMap.qtyToShip);
      item.isDirty = true;
    }
  };
  const changeMaterialItem = (params) => { 
    const { type, item, isCutOrder } = params;
    const catQtyMap = isCutOrder ? item :getCatQTyMap(item);
    catQtyMap.isDirty = true;
    if (type === 'qtyToConsume') {
      if (params.item.qtyToConsume > params.item.quantity) {
        toast.warning('qtyToConsume cannot be greater than Qty Needed');
        params.item.qtyToConsume = params.item.quantity;
      }
      catQtyMap.qtyToShip = params.item.qtyToShip = parseFloat((catQtyMap.total - catQtyMap.qtyToConsume).toFixed(4));
      catQtyMap.qtyToConsume = parseFloat((isCutOrder ? item.qtyToConsume : (item.qtyToConsume - item.qtyConsumed)).toFixed(4));
      updateItemQty(catQtyMap, item);
    } else if (type === 'qtyToShip') {
      catQtyMap.qtyToConsume = params.item.qtyToConsume = parseFloat((catQtyMap.total - catQtyMap.qtyToShip).toFixed(4));
      catQtyMap.qtyToShip = parseFloat((catQtyMap.total - catQtyMap.qtyToConsume).toFixed(4));
      catQtyMap[type] = item[type];
      if (catQtyMap.qtyToConsume === '') {
        catQtyMap.qtyToConsume = 0;
      }
      if (catQtyMap.qtyToShip === '') {
        catQtyMap.qtyToShip = 0;
      }
      updateItemQty(catQtyMap, item);
    } else {
      // eslint-disable-next-line no-multi-assign
      catQtyMap[type] = item[type] = item[`${type}Old`];
    }
  };
  const validateQTy = (params) => {
    const { type, item, isCutOrder } = params;
    const otherType = (type === 'qtyToConsume') ? 'qtyToShip' : 'qtyToConsume';
    const catQtyMap = isCutOrder ? item : getCatQTyMap(item);
    if (!_.isEmpty(catQtyMap)
      && (catQtyMap[type] + catQtyMap[otherType] !== item.quantity)
      && item.purpose === 'kit') {
      const val = item.quantity - catQtyMap[type];
      item[otherType] = val;
      catQtyMap[otherType] = val;
      updateItemQty(catQtyMap, item);
    }
  };
  const calculateMax = (item, type) => {
    if (item.purpose === 'assembly') {
      return QtyOptions.QTY_MAX;
    }
    const { catQtyMaps } = item;
    const predicate = {};
    if (_.isEmpty(item.catId)) {
      predicate._id = item._id;
    } else {
      predicate.catId = item.catId;
    }
    const catQtyMap = _.find(catQtyMaps, predicate);
    if (_.isEmpty(catQtyMap)) { return 0; }
    if (type === 'qtyToConsume') {
      return item.quantity + item.qtyConsumed - catQtyMap.qtyToShip;
    }
    return item.quantity - catQtyMap.qtyToConsume;
  };

  const consumeAndUnreserve = async (params) => {
    try {
      await Shipping.consumeAndUnreserve(params);
    } catch (e) {
      console.log('Error', e);
      throw e;
    }
    return true;
  };

  return {
    ...toRefs(state),
    getCatQTyMap,
    updateItemQty,
    changeMaterialItem,
    validateQTy,
    calculateMax,
    consumeAndUnreserve,

  };
}
